










import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class IconInvestedRoundedType2 extends Vue {
  @Prop({ type: String, default: "#ffffff" }) iconColor!: string;
  @Prop({ type: String, default: "#ee1c25" }) bgColor!: string;
}
